export const MEDICAL_NOTE_PROMPT_SLUGS = {
  SELECTOR: 'ed-note-module-selector',
  CORE: 'medical-note-core',
} as const;

export const FLOW_ROUTER_PROMPT_SLUG = 'flow-router';

// Whether a flow's prompt slug resolves in the backend's Braintrust environment. 'unknown' means the
// check itself couldn't complete (Braintrust unreachable) and must not block the admin's save.
export const promptSlugStatuses = ['found', 'missing', 'unknown'] as const;

export type PromptSlugStatus = (typeof promptSlugStatuses)[number];
